import { useState } from 'react';
import BookingUnprocessedOverlay from '../BookingUnprocessedOverlay/BookingUnprocessedOverlay';
import LargeButton from '../LargeButton/LargeButton';
import MarkAsUnprocessed from '../MarkAsUnprocessed/MarkAsUnprocessed';
import {
	bookSequenceNumber,
	submitMarkUnprocessed,
	updatePartValidation,
} from '../../redux/actionCreators/partValidation';
import { connect } from 'react-redux';
import { useMessageContextManager } from '../MessageOverlay/MessageOverlay';
import { ERROR_MESSAGE } from '../../constants';
import { updateCurrentLineItem } from '../../redux/actionCreators/station';
import { updateReceivePart } from '../../redux/actionCreators/receivePart';
import { updateScanAttribute } from '../../redux/actionCreators/scanAttribute';

const mapDispatchToProps = (dispatch) => ({
	bookSequenceNumber: (sequenceNumber, successCallback, errorCallback) =>
		dispatch(
			bookSequenceNumber(sequenceNumber, successCallback, errorCallback),
		),
	submitMarkUnprocessed: (
		sequenceNumber,
		payload,
		successCallback,
		errorCallback,
	) =>
		dispatch(
			submitMarkUnprocessed(
				sequenceNumber,
				payload,
				successCallback,
				errorCallback,
			),
		),
	updatePartValidation: (data) => dispatch(updatePartValidation(data)),
	updateReceivePart: (data) => dispatch(updateReceivePart(data)),
	updateCurrentLineItem: (data) => dispatch(updateCurrentLineItem(data)),
	updateScanAttribute: (data) => dispatch(updateScanAttribute(data))
});

export const TakeOut = ({
	submitMarkUnprocessed,
	updateReceivePart,
	updatePartValidation,
	updateCurrentLineItem,
	redirectToNextScreen,
	updateScanAttribute,
	partDetails,
	btnStyles = {},
}) => {
	const [openMarkUnprocessed, setOpenMarkUnprocessed] = useState(false);
	const [successUnprocessedOverlay, setSuccessUnprocessedOverlay] =
		useState(false);
	const { showMessageOverlay } = useMessageContextManager();

	const markAsUnprocessed = () => {
		setOpenMarkUnprocessed(true);
	};	

	const onMarkUnprocessedSubmit = (reason, remarks) => {
		submitMarkUnprocessed(
			partDetails.sequenceNumber,
			{ reason, remarks },
			(data) => {
				setOpenMarkUnprocessed(false);
				setSuccessUnprocessedOverlay(true);
			},
			(error) => {
				setOpenMarkUnprocessed(false);
				showMessageOverlay({
					contextText: ERROR_MESSAGE.ERROR_CONTEXT_TEXT + 'Take Out.',
					info: error?.response?.data?.message,
					error: true,
				});
				// logError(`Take out ${error}`);
			},
		);
	};

	const closeUnprocessedOverlay = () => {
		setSuccessUnprocessedOverlay(false);
		updateReceivePart({});
		updatePartValidation({});
		updateScanAttribute({});
		updateCurrentLineItem(null);
		if (redirectToNextScreen) redirectToNextScreen();
	};

	return (
		<>
			<LargeButton
				backgroundColor="#E47778"
				name="TAKE OUT"
				sx={{ ...btnStyles }}
				onClick={markAsUnprocessed}
			/>
			{successUnprocessedOverlay && (
				<BookingUnprocessedOverlay
					serialNumber={partDetails.serialNumber}
					onClose={closeUnprocessedOverlay}
				/>
			)}
			{openMarkUnprocessed && (
				<MarkAsUnprocessed
				partDetails={partDetails}
					open={openMarkUnprocessed}
					handleClose={() => setOpenMarkUnprocessed(false)}
					handleSubmit={onMarkUnprocessedSubmit}
				/>
			)}
		</>
	);
};

export default connect(null, mapDispatchToProps)(TakeOut);
